<template>
    <div>
        <div class="vx-row">
            <vs-card>
                <div slot="header">
                    <h5>Total plaintes par période</h5>
                </div>
                <vs-row>
                    <div class="flex -mx-2">
                        <div class="w-2/4 px-2">
                            <span class="vs-select--label">Période</span>
                            <date-range-picker
                                ref="picker"
                                :opens="opens"
                                :locale-data=locale
                                :singleDatePicker="false"
                                :timePicker=false
                                :showWeekNumbers="showWeekNumbers"
                                :showDropdowns="showDropdowns"
                                :autoApply="autoApply"
                                v-model="dateRange"
                                :ranges=false
                                @update="updateValues"
                                :linkedCalendars="linkedCalendars"
                                :dateFormat="dateFormat"
                                :always-show-calendars="false"
                                :alwaysShowCalendars="alwaysShowCalendars"
                                class="vs-inputx vs-input--input"
                            >
                                <div slot="input" slot-scope="picker" style="min-width: 350px;">
                                {{ picker.startDate | date }} - {{ picker.endDate | date }}
                                </div>
                            </date-range-picker>
                        </div>
                        <div class="w-1/8 px-2">
                            <vs-button :disabled="dateRange.startDate === '' && dateRange.endDate === ''" @click="makeSearch()" style="margin-top: 18px;" color="primary"
                                        type="filled" icon="search">Recherche
                            </vs-button>
                        </div>
                    </div>
                </vs-row><br><br>

                <div class="app-dashboard">

                    <div class="vx-row">
                        <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
                            <vx-card class="overflow-hidden">
                                <div slot="no-body">
                                    <div class="p-6 flex justify-between flex-row-reverse items-center">
                                    <div class="truncate">
                                        <h2 class="mb-1 font-bold"> {{ total_complaint }} </h2>
                                        <span>Totales plaintes reçues</span>
                                    </div>
                                    </div>
                                </div>
                            </vx-card>
                        </div>

                        <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
                            <vx-card class="overflow-hidden" card-background="success" content-color="white">
                                <div slot="no-body">
                                    <div class="p-6 flex justify-between flex-row-reverse items-center">
                                    <div class="truncate">
                                        <h2 class="mb-1 text-white"> {{total_complaint_new}} </h2>
                                        <span>Totales plaintes nouveau</span>
                                    </div>
                                    </div>
                                </div>
                            </vx-card>
                        </div>

                        <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
                            <vx-card class="overflow-hidden" card-background="danger" content-color="white">
                                <div slot="no-body">
                                    <div class="p-6 flex justify-between flex-row-reverse items-center">
                                    <div class="truncate">
                                        <h2 class="mb-1 font-bold text-white"> {{total_complaint_in_progress}} </h2>
                                        <span>Totales plaintes en cours</span>
                                    </div>
                                    </div>
                                </div>
                            </vx-card>
                        </div>

                        <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
                            <vx-card class="overflow-hidden">
                                <div slot="no-body">
                                    <div class="p-6 flex justify-between flex-row-reverse items-center">
                                    <div class="truncate">
                                        <h2 class="mb-1 font-bold"> {{ total_treat }} </h2>
                                        <span>Totales plaintes fermées</span>
                                    </div>
                                    </div>
                                </div>
                            </vx-card>
                        </div>

                        <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
                            <vx-card class="overflow-hidden" card-background="danger" content-color="white">
                                <div slot="no-body">
                                    <div class="p-6 flex justify-between flex-row-reverse items-center">
                                    <div class="truncate">
                                        <h2 class="mb-1 font-bold text-white"> {{total_reject}} </h2>
                                        <span>Total plaintes rejetées</span>
                                    </div>
                                    </div>
                                </div>
                            </vx-card>
                        </div>

                        <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
                            <vx-card class="overflow-hidden" card-background="primary"
                                    content-color="#fff">
                                <div slot="no-body">
                                    <div class="p-6 flex justify-between flex-row-reverse items-center">
                                    <div class="truncate">
                                        <h2 class="mb-1 font-bold text-white"> {{total_report}} </h2>
                                        <span>Total plaintes reportées</span>
                                    </div>
                                    </div>
                                </div>
                            </vx-card>
                        </div>
                    </div>
                </div>
            </vs-card>
        </div>
    </div>
    
</template>
<script>
import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import moment from "moment";
export default {
    name : "totalRequest",
    components: {DateRangePicker},
    data: () => ({
        total_complaint: 0,
        total_complaint_new: 0,
        total_complaint_in_progress: 0,
        total_treat: 0,
        total_reject: 0,
        total_report: 0,
        user: 0,
        category: '',
        stats: [],
        requests: [],
        last_page: null,
        page: 1,
        opens: 'right',
        showWeekNumbers: true,
        linkedCalendars: true,
        alwaysShowCalendars: true,
        showDropdowns: true,
        autoApply: false,
        locale: {
            direction: 'ltr',
            format: 'dd/mm/yyyy',
            separator: ' - ',
            applyLabel: 'Appliquer',
            cancelLabel: 'Annuler',
            weekLabel: 'W',
            customRangeLabel: 'Custom Range',
            daysOfWeek: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
            monthNames: ['Jan', 'Fev', 'Mar', 'Avr', 'Mai', 'Jui', 'Juil', 'Aou', 'Sep', 'Oct', 'Nov', 'Dec'],
            firstDay: 0
        },
        dateRange: {
            startDate: "",
            endDate: "",
        },
        dateFormat(classes, date) {
            let yesterday = moment().subtract(1, 'day');
            if (!classes.disabled) {
            }
        return classes
        },
    }),
    mounted(){
        this.dateRange.startDate = moment(new Date()).format('YYYY-MM-DD')
        this.dateRange.endDate = moment(new Date()).format('YYYY-MM-DD')
        this.makeSearch()
    },
    methods:{
        updateValues(values) {
            this.dateRange.startDate = moment(values.startDate).format('YYYY-MM-DD');
            this.dateRange.endDate = moment(values.endDate).format('YYYY-MM-DD');
        },
        
        makeSearch() {
            this.$vs.loading()
            this.$http.post('/cex/request-plaint-period', {
                date_debut: this.dateRange.startDate,
                date_fin: this.dateRange.endDate,
            }).then((response) => {
            let content = response.data
            this.total_complaint = content['total_complaint']
            this.total_complaint_new = content['total_complaint_new']
            this.total_complaint_in_progress = content['total_complaint_in_progress']
            this.total_treat = content['total_treat']
            this.total_reject = content['total_reject']
            this.total_report = content['total_report']
            this.$vs.loading.close()
            }).catch((error) => {
                this.$vs.loading.close()
                if (error.response.status === 401){
                    this.$router.push({name: 'login'})
                }else{
                    console.log(error)
                }
            })
        },
    }
}
</script>

<style lang="scss">
  @import "@/assets/scss/vuesax/components/vxTimeline.scss";
</style>